import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import findLastIndex from 'lodash/findLastIndex'

import { Tabs, Tab } from 'components/atoms'

interface Props {
  color?: 'light'
  links: {
    label: string | React.ReactElement
    path: string
    matchPath?: string
    disabled?: boolean
    onClick?: (tabIndex: number) => void
  }[]
}

export const RouterTabs: React.FC<Props> = ({ links, ...props }) => {
  const { pathname } = useLocation()
  const matches = links.map((link) => pathname.startsWith(link.matchPath || link.path))
  const index = findLastIndex(matches, (match) => match)

  return (
    <Tabs index={index} {...props}>
      {links.map(({ path, disabled, label, onClick = () => {} }, index) => (
        <Tab key={`${path}${index}`} disabled={disabled}>
          <Link
            to={path}
            onClick={() => {
              onClick(index)
            }}
            css={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'left',
              color: 'inherit',
              height: '100%',

              maxWidth: 300,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',

              '&:hover': {
                color: 'inherit',
                textDecoration: 'none',
              },
            }}
          >
            {label}
          </Link>
        </Tab>
      ))}
    </Tabs>
  )
}
